import { Component, EventEmitter, Input, Output } from '@angular/core'
import { toDate, diffWeeks, diffDays } from 'app/utils/date'
import { ContextService } from '../../services'
import { TranslateService } from '@ngx-translate/core'
import { environment } from 'environments/environment'

@Component({
  standalone: false,
  selector: 'app-campaign-widget',
  templateUrl: './campaign-widget.component.html',
  styleUrls: ['./campaign-widget.component.scss'],
})
export class CampaignWidgetComponent {
  @Input() title = ''
  @Input() campaign = null
  @Input() comparedCampaign = null
  @Input() campaignPOIs = []
  @Input() comparedCampaignPOIs = []
  @Input() showOnlyCommonPOIs = false

  @Output() onClickViewFullTable = new EventEmitter()
  @Output() onDeleteCampaign = new EventEmitter()
  @Output() onToggleCommonPOIs = new EventEmitter()

  get currentDelivery() {
    return this.context.vertical.delivery
  }

  get hasCampaignCreation() {
    return (
      this.currentDelivery && this.currentDelivery.config.hasCampaignCreation
    )
  }

  get referenceTitle() {
    return this.comparedCampaign ? 'Reference campaign' : 'Campaign'
  }

  constructor(
    protected context: ContextService,
    protected translate: TranslateService,
  ) {}

  formatDate(str: string) {
    return new Date(str).toLocaleDateString()
  }

  get deliveryCountLabel() {
    let translations = ''
    if (!environment.politis) {
      translations = this.translate.instant(
        'The campaigns lasts {{num_deliveries}} deliveries ({{num_days}} days)',
        {
          num_deliveries: this.getNumDeliveries(this.campaign),
          num_days: this.getNumDays(this.campaign),
        },
      )
    } else {
      const num_days = this.getNumDays(this.campaign)
      const periods = Math.floor(num_days / 14)
      const has_period = num_days % 14 === 0
      if (!has_period) {
        translations = this.translate.instant(
          'The campaign lasts {{num_days}} days',
          {
            num_days: num_days,
          },
        )
      } else if (has_period && periods === 1) {
        translations = this.translate.instant(
          'Campaign lasts {{periods}} period ({{num_days}} days)',
          {
            periods: periods,
            num_days: num_days,
          },
        )
      } else {
        translations = this.translate.instant(
          'Campaign lasts {{periods}} periods ({{num_days}} days)',
          {
            periods: periods,
            num_days: num_days,
          },
        )
      }
    }

    return translations
  }

  getNumDeliveries(campaign) {
    if (!campaign) {
      return
    }
    const start = toDate(campaign.start)
    const end = toDate(campaign.finish)
    const weeks = diffWeeks(end, start)
    const value = Math.round(weeks / 2)
    return value || '< 1'
  }

  getNumDays(campaign) {
    if (!campaign) {
      return
    }

    return diffDays(toDate(campaign.finish), toDate(campaign.start)) + 1
  }

  showAll() {
    this.onClickViewFullTable.emit()
  }

  deleteCampaign() {
    this.onDeleteCampaign.emit()
  }

  toggleCommonPOIsView() {
    this.onToggleCommonPOIs.emit()
  }
}
